import { Link } from 'react-router-dom';
import { Button, Row, Col, Card, ListGroup, Badge } from 'react-bootstrap';
import { FaChevronLeft } from 'react-icons/fa';
import { LinkContainer } from 'react-router-bootstrap';
import Message from '../components/Message';
import Loader from '../components/Loader';
import { useGetMyOrdersQuery } from "../slices/ordersApiSlice";

const ProfileOrderScreen = () => {
    const { data: orders, isLoading, error: errorOrders } = useGetMyOrdersQuery();

    return (
        <div className="account-page">
            <Link to="/profile" className="account-back"><FaChevronLeft aria-hidden="true" /> My Account</Link>
            <h1 className="account-title">My Orders</h1>

            <Card className="shadow-sm">
                        <Card.Body className="p-0">
                            {isLoading ? (
                                <div className="p-4">
                                    <Loader />
                                </div>
                            ) : errorOrders ? (
                                <div className="p-4">
                                    <Message variant='danger'>
                                        {errorOrders?.data?.message || errorOrders.error}
                                    </Message>
                                </div>
                            ) : orders?.length === 0 ? (
                                <div className="text-center p-5">
                                    <i className="fas fa-inbox fa-3x text-muted mb-3"></i>
                                    <h5>No Orders Yet</h5>
                                    <p className="text-muted">Start shopping to see your orders here!</p>
                                    <Button
                                        variant="primary"
                                        className="blue-outline"
                                        onClick={() => window.location.href = '/'}
                                    >
                                        <i className="fas fa-shopping-cart"></i> Start Shopping
                                    </Button>
                                </div>
                            ) : (
                                <ListGroup variant="flush">
                                    {orders?.map((order) => (
                                        <ListGroup.Item key={order._id} className="p-3">
                                            <Row className="align-items-center">
                                                {/* Order Number & Date */}
                                                <Col md={3}>
                                                    <div className="mb-1">
                                                        <small className="text-muted">Order #</small>
                                                        <br />
                                                        <strong>{order.orderNumber || `${order._id.substring(0, 10)}...`}</strong>
                                                    </div>
                                                    <div>
                                                        <small className="text-muted">
                                                            <i className="fas fa-calendar"></i>{' '}
                                                            {new Date(order.createdAt).toLocaleDateString('en-GB')}
                                                        </small>
                                                    </div>
                                                </Col>

                                                {/* Total Amount */}
                                                <Col md={2} className="text-center">
                                                    <small className="text-muted d-block">Total</small>
                                                    <strong className="text-primary fs-5">£{order.totalPrice.toFixed(2)}</strong>
                                                </Col>

                                                {/* Payment Status */}
                                                <Col md={2} className="text-center">
                                                    <small className="text-muted d-block mb-1">Payment</small>
                                                    {order.isPaid ? (
                                                        <Badge bg="success">
                                                            <i className="fas fa-check-circle"></i> Paid
                                                        </Badge>
                                                    ) : (
                                                        <Badge bg="danger">
                                                            <i className="fas fa-times-circle"></i> Unpaid
                                                        </Badge>
                                                    )}
                                                </Col>

                                                {/* Delivery Status */}
                                                <Col md={2} className="text-center">
                                                    <small className="text-muted d-block mb-1">Delivery</small>
                                                    {order.isDelivered ? (
                                                        <Badge bg="success">
                                                            <i className="fas fa-truck"></i> Delivered
                                                        </Badge>
                                                    ) : order.cancelledAt ? (
                                                        <Badge bg="danger">
                                                            <i className="fas fa-ban"></i> Cancelled
                                                        </Badge>
                                                    ) : (
                                                        <Badge bg="warning" text="dark">
                                                            <i className="fas fa-box"></i> Processing
                                                        </Badge>
                                                    )}
                                                </Col>

                                                {/* Action Button */}
                                                <Col md={3} className="text-end">
                                                    <LinkContainer to={`/order/${order._id}`}>
                                                        <Button
                                                            variant='outline-primary'
                                                            size="sm"
                                                            className="w-100"
                                                        >
                                                            <i className="fas fa-eye"></i> View Details
                                                        </Button>
                                                    </LinkContainer>
                                                </Col>
                                            </Row>
                                        </ListGroup.Item>
                                    ))}
                                </ListGroup>
                            )}
                        </Card.Body>

                        {/* Order Summary Footer */}
                        {orders && orders.length > 0 && (
                            <Card.Footer className="bg-light text-center">
                                <small className="text-muted">
                                    <i className="fas fa-info-circle"></i> Total Orders: <strong>{orders.length}</strong>
                                    {' | '}
                                    Total Spent: <strong>£{orders.reduce((acc, order) => acc + order.totalPrice, 0).toFixed(2)}</strong>
                                </small>
                            </Card.Footer>
                        )}
                    </Card>
        </div>
    );
};

export default ProfileOrderScreen;